const currencyEnum = [
  "GBP",
  "USD",
  "NGN",
  "EUR",
  "BRL",
  "INR",
  "AED",
  "CAD",
  "MYR",
] as const;
const currencySymbolEnum = [
  "€",
  "£",
  "₦",
  "$",
  "R$",
  "₹",
  "AED",
  "CA$",
  "MYR",
] as const;
export type CurrencyEnumType = (typeof currencyEnum)[number];
export type CurrencySymbolEnumType = (typeof currencySymbolEnum)[number];
type CurrencySymbolMapType = Record<CurrencyEnumType, CurrencySymbolEnumType>;

export const CURRENCY_SYMBOL_MAP: CurrencySymbolMapType = {
  AED: "AED",
  BRL: "R$",
  CAD: "CA$",
  EUR: "€",
  GBP: "£",
  INR: "₹",
  MYR: "MYR",
  NGN: "₦",
  USD: "$",
};
